if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
          // Änderung Anfang - Dot Navigation
          galleryDots: this.querySelector('.product-gallery-dots'),
          // Änderung Ende
        };
        this.mql = window.matchMedia('(min-width: 750px)');

        // Änderung Anfang - Setup für Dot Navigation
        if (this.elements.galleryDots) {
          // Initial: Ersten aktiven Slide finden und Dot markieren
          const activeSlide = this.elements.viewer.querySelector('.slider__slide.is-active') ||
                              this.elements.viewer.querySelector('.slider__slide');
          if (activeSlide && activeSlide.dataset.mediaId) {
            this.updateGalleryDots(activeSlide.dataset.mediaId);
          }

          // Event listener für Slide-Wechsel
          this.elements.viewer.addEventListener('slideChanged', (event) => {
            const mediaId = event.detail.currentElement.dataset.mediaId;
            this.updateGalleryDots(mediaId);
          });

          // Scroll-basierte Erkennung als Backup
          const slider = this.elements.viewer.querySelector('.slider');
          if (slider) {
            let scrollTimeout;
            slider.addEventListener('scroll', () => {
              clearTimeout(scrollTimeout);
              scrollTimeout = setTimeout(() => {
                const slides = slider.querySelectorAll('.slider__slide');
                const sliderRect = slider.getBoundingClientRect();
                const sliderCenter = sliderRect.left + sliderRect.width / 2;

                let closestSlide = null;
                let closestDistance = Infinity;

                slides.forEach((slide) => {
                  const slideRect = slide.getBoundingClientRect();
                  const slideCenter = slideRect.left + slideRect.width / 2;
                  const distance = Math.abs(slideCenter - sliderCenter);

                  if (distance < closestDistance) {
                    closestDistance = distance;
                    closestSlide = slide;
                  }
                });

                if (closestSlide) {
                  const mediaId = closestSlide.dataset.mediaId;
                  if (mediaId) {
                    this.updateGalleryDots(mediaId);
                  }
                }
              },10);
            }, { passive: true });
          }

          // Klick-Handler für Dots
          this.elements.galleryDots.querySelectorAll('.product-gallery-dot').forEach((dot) => {
            dot.addEventListener('click', this.setActiveMedia.bind(this, dot.dataset.mediaId, false));
          });
        }
        // Änderung Ende

        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const mediaId = event.detail.currentElement.dataset.mediaId;

        if (!this.elements.thumbnails) return;
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        // Änderung Anfang - Update Dot Navigation
        if (this.elements.galleryDots) {
          this.updateGalleryDots(mediaId);
        }
        // Änderung Ende

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      // Änderung Anfang - Methode für Dot Navigation
      updateGalleryDots(mediaId) {
        if (!this.elements.galleryDots) return;
        this.elements.galleryDots.querySelectorAll('.product-gallery-dot').forEach((dot) => {
          dot.classList.toggle('is-active', dot.dataset.mediaId === mediaId);
        });
      }
      // Änderung Ende

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
